export default {"src":"/_next/static/media/badbreath.ec791e19.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};